export default __webpack_public_path__ + "static/tab6Img-36b7275f9d64230b1598042d90947a45.png";